import { createFileRoute } from '@tanstack/react-router';
import { McpGlobalLimitsPage } from '@/features/admin/pages/mcp';

export const Route = createFileRoute('/admin/mcp/limits')({
  component: McpGlobalLimitsPage,
});
